import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';
import { useSetVersionAsCurrentMutation } from 'api/parameter.api';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useState } from 'react';
import { toast } from 'react-toastify';

export default function ParameterVersion({
  open,
  handleClose,
  version,
  search,
}) {
  const [viewValue, setViewValue] = useState([]);
  const [setVersionAsCurrent] = useSetVersionAsCurrentMutation();

  const handleValueView = (index) => {
    viewValue.includes(index)
      ? setViewValue(viewValue.filter((i) => i !== index))
      : setViewValue([...viewValue, index]);
  };

  const makeCurrent = async () => {
   const res = await setVersionAsCurrent(version._id);
    
    if (res.data) {
      toast.success(res.data.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      await search();
      handleClose();
    } else {
      toast.error(res.error.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        fullWidth='true'
        maxWidth='lg'
      >
        <DialogTitle id='form-dialog-title'>Parameter Version</DialogTitle>
        <br />
        <DialogContent>
          <GridContainer alignItems='top' justifyContent='center'>
            <GridItem xs={5}>
              <Typography variant='h6'>Version Details</Typography>
              <br />
              <Typography>
                <b>Version:</b> {version?.version}{' '}
                {version.isCurrent ? (
                  <Chip sx={{ marginLeft: 1 }} size='small' label='Current' />
                ) : !version.currentParameter.length ? (
                  <Chip
                    sx={{ marginLeft: 1 }}
                    size='small'
                    label='Deleted'
                    color='error'
                  />
                ) : (
                  ''
                )}
              </Typography>
              <br />
              <Typography>
                <b>Name:</b> {version?.name}
              </Typography>
              <br />
              <Typography>
                <b>Description:</b> {version?.description}
              </Typography>
              <br />
              <Typography>
                <b>Type:</b> {version?.type}
              </Typography>
              <br />
              <Typography>
                <b>Temporary:</b> {version?.temporary.toString()}
              </Typography>
              <br />
              <Typography>
                <b>Start Date:</b>{' '}
                {version?.start_date
                  ? new Date(version?.start_date).toLocaleString('en-US', {
                      weekday: 'short',
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                    })
                  : 'No Start Date'}
              </Typography>
              <br />
              <Typography>
                <b>End Date:</b>{' '}
                {version?.end_date
                  ? new Date(version?.end_date).toLocaleString('en-US', {
                      weekday: 'short',
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                    })
                  : 'No End Date'}
              </Typography>
              <br />
              <Typography>
                <b>Date Changed:</b>{' '}
                {new Date(version?.created_at).toLocaleString('en-US', {
                  weekday: 'short',
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })}
              </Typography>
              <br />
              <Typography>
                <b>Changed By:</b> {version?.created_by}
              </Typography>
            </GridItem>
            <GridItem xs={5}>
              <Typography variant='h6'>Parameters</Typography>
              <br />
              <Box sx={{ overflowY: 'auto', maxHeight: 300 }}>
                {version?.parameters.map((param, index) => (
                  <div key={index}>
                    <div>
                      <Typography>
                        <b>Parameter:</b> {param.name}
                      </Typography>
                      <Typography>
                        <b>Type:</b> {param.type}
                      </Typography>
                      <Typography
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleValueView(index)}
                      >
                        {viewValue.includes(index) ? (
                          <>
                            <b>Value:</b> {param.value}
                          </>
                        ) : (
                          <>
                            <b>Value:</b> {param.value.slice(0, 50)}...
                          </>
                        )}
                      </Typography>
                    </div>
                    <hr />
                  </div>
                ))}
              </Box>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <ThemedPrimaryBtn disabled={version?.isCurrent || !version?.currentParameter?.length} onClick={makeCurrent}>
            Make Current
          </ThemedPrimaryBtn>
          <ThemedSecondaryBtn onClick={handleClose}>Close</ThemedSecondaryBtn>
        </DialogActions>
      </Dialog>
    </div>
  );
}
